import modal from './Modal';
import form from './Form';
import nav from './Nav';
import { TrackingService } from './Tracking';

require('focus-visible');

(function () {
    var pageLoadFunctions = {
        /* Initialize methods on page load */
        init: function () {
            const tracking = TrackingService.getInstance();
            tracking.trackPage();
            modal.init();
            form.init();
            nav.init();
            document.addEventListener('click', (e) => { tracking.trackInteraction(e); });
            const inputs = document.querySelectorAll('input');
            inputs.forEach(input => {
                input.addEventListener('focusout', (e) => {
                    tracking.trackInteraction(e);
                });
            })
        }
    };
    document.onreadystatechange = function () {
        if (document.readyState === 'complete') {
            pageLoadFunctions.init();
        }
    };
})();


//Privacy Footer Update - Analytics update for cookie settings link
const cookieSettingsElement = document.getElementById("ot-sdk-btn");
cookieSettingsElement.addEventListener("click", cookieAnalyticsData);

function cookieAnalyticsData(e) {
    const trackingCookieData = TrackingService.getInstance();
    trackingCookieData.trackInteraction(e);
}

